import { SafeDictionary } from "@insite/client-framework/Common/Types";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { Handler, makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DisplayProductsResult,
    LoadRealTimeInventory,
    LoadRealTimePrices,
    SetExpandTokens,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}
type HandlerType = Handler<Parameter, Props>;

export const SetExpandTokensProperties: HandlerType = props => {
    props.expandTokens = ["attributes", "facets", "variantTraits", "properties", "badges"];
};

export const CustomLoadRealTimeInventory: HandlerType = props => {
    // const state = props.getState();
    // if (state.context.settings.properties.realTimeInventory === "true") {
    //     if (!props.result.products?.length || getIsWebCrawler()) {
    //         return;
    //     }

    //     props.dispatch(
    //         loadRealTimeInventory({
    //             productIds: props.result.products.map(o => o.id),
    //             onSuccess: realTimeInventory => {
    //                 props.dispatch({
    //                     type: "Pages/ProductList/CompleteLoadRealTimeInventory",
    //                     realTimeInventory,
    //                 });
    //             },
    //             onError: () => {
    //                 props.dispatch({
    //                     type: "Pages/ProductList/FailedLoadRealTimeInventory",
    //                 });
    //             },
    //             onComplete(realTimeInventoryProps) {
    //                 if (realTimeInventoryProps.apiResult) {
    //                     this.onSuccess?.(realTimeInventoryProps.apiResult);
    //                 } else if (realTimeInventoryProps.error) {
    //                     this.onError?.(realTimeInventoryProps.error);
    //                 }
    //             },
    //         }),
    //     );
    // }
};

export const CustomLoadRealTimePrices: HandlerType = async props => {
    // const state = props.getState();
    // if (state.context.settings.properties.realTimePricing === "true") {
    //     const {
    //         result: { productInfosByProductId },
    //     } = props;
    //     const productIds = Object.keys(productInfosByProductId);
    //     if (productIds.length === 0) {
    //         return;
    //     }

    //     const loadRealTimePricingParameter: Parameters<typeof loadRealTimePricing>[0] = {
    //         productPriceParameters: productIds.map(o => productInfosByProductId[o]!),
    //         onSuccess: realTimePricing => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/CompleteLoadRealTimePricing",
    //                 realTimePricing,
    //             });
    //             props.pricingLoaded = true;
    //         },
    //         onError: () => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/FailedLoadRealTimePricing",
    //             });
    //             props.pricingLoaded = true;
    //         },
    //         onComplete(realTimePricingProps) {
    //             if (realTimePricingProps.apiResult) {
    //                 this.onSuccess?.(realTimePricingProps.apiResult);
    //             } else if (realTimePricingProps.error) {
    //                 this.onError?.(realTimePricingProps.error);
    //             }
    //         },
    //     };

    //     if (IS_SERVER_SIDE && getIsWebCrawler()) {
    //         const awaitableLoadRealTimePricing = makeHandlerChainAwaitable<
    //             Parameters<typeof loadRealTimePricing>[0],
    //             RealTimePricingModel
    //         >(loadRealTimePricing);
    //         const realTimePricing = await awaitableLoadRealTimePricing({
    //             productPriceParameters: loadRealTimePricingParameter.productPriceParameters,
    //         })(props.dispatch, props.getState);
    //         if (realTimePricing) {
    //             loadRealTimePricingParameter.onSuccess?.(realTimePricing);
    //         } else {
    //             loadRealTimePricingParameter.onError?.(realTimePricing);
    //         }
    //     } else {
    //         props.dispatch(loadRealTimePricing(loadRealTimePricingParameter));
    //     }

    //     const productSettings = getSettingsCollection(props.getState()).productSettings;
    //     if (productSettings.canSeePrices && productSettings.inventoryIncludedWithPricing) {
    //         await waitFor(() => !!props.pricingLoaded);
    //     }
    // }
};
replaceInChain(chain, SetExpandTokens, SetExpandTokensProperties);
replaceInChain(chain, LoadRealTimeInventory, CustomLoadRealTimeInventory);
replaceInChain(chain, LoadRealTimePrices, CustomLoadRealTimePrices);
